/* Dansk katalog for locale-invoice-detail-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'inv.detail.completion': 'Gennemførelse',
  'inv.detail.completed': 'Gennemført',
  'inv.detail.notCompleted': 'Ikke gennemført',
  'inv.detail.paymentStatus': 'Betalingsstatus',
  'inv.detail.paid': 'Betalt',
  'inv.detail.remaining': 'Resterende',
  'inv.detail.registeredPayments': 'Registrerede betalinger',
  'inv.detail.registerPayment': 'Registrér betaling',
  'inv.detail.settlementStatus': 'Afregning',
  'inv.detail.creditOffset': 'Modregnet',
  'inv.detail.creditRefunded': 'Tilbagebetalt',
  'inv.detail.creditOpen': 'Ikke tilbagebetalt',
  'inv.detail.offsetAgainst': 'Modregnet mod {document}',
  'inv.detail.offsetAgainstInvoice': 'Modregnet mod fakturaen',
  'inv.detail.refunded': 'Tilbagebetalt',
  'inv.detail.toCredit': 'Til gode',
  'inv.detail.registeredRefunds': 'Registrerede tilbagebetalinger',
  'inv.detail.registerRefund': 'Registrér tilbagebetaling',
  'inv.detail.amountTitle': 'Beløb',
  'inv.detail.amountHelp': 'Netto, moms og totalbeløb er beregnet ud fra de gemte fakturalinjer.',
  'inv.detail.net': 'Netto',
  'inv.detail.totalAmount': 'Samlet beløb',
  'inv.detail.history': 'Historik',
  'inv.detail.action': 'Handling',
  'inv.detail.loadingDoc': 'Indlæser dokument...',
  'inv.detail.openedFromLink': 'Dokument åbnet fra link',
  'inv.act.open': 'Åbn',
  'inv.act.openHelp': 'Åbn udkastet i Nyt salg for at redigere og sende det.',
  'inv.act.send': 'Send',
  'inv.act.sendAgain': 'Send igen',
  'inv.act.sendCreditNote': 'Send kreditnota',
  'inv.act.sendHelp': 'Send dokumentet til kunden på e-mail via backend.',
  'inv.act.markDelivered': 'Markér som leveret',
  'inv.act.markDeliveredHelp': 'Brug, når dokumentet er leveret til kunden uden for Plumme.',
  'inv.act.view.invoice': 'Se faktura',
  'inv.act.view.quote': 'Se tilbud',
  'inv.act.view.orderConfirmation': 'Se ordrebekræftelse',
  'inv.act.view.creditNote': 'Se kreditnota',
  'inv.act.viewHelp': 'Forhåndsvis dokumentet, som kunden ser det.',
  'inv.act.copyLink': 'Kopiér link',
  'inv.act.copyLinkHelp': 'Kopiér et link til dokumentet, som kan deles.',
  'inv.act.download': 'Download',
  'inv.act.downloadHelp': 'Download dokumentet som PDF.',
  'inv.act.packingSlip': 'Opret pakseddel',
  'inv.act.packingSlipHelp': 'Opret og download en pakseddel for varerne på denne faktura.',
  'inv.act.copy': 'Opret kopi',
  'inv.toast.copyOpened': 'Kopien er åbnet — gem den som udkast, eller opret den',
  'inv.act.share': 'Del',
  'inv.act.shareHelp': 'Kopiér delingslink, download PDF eller opret pakseddel.',
  'inv.share.title': 'Del dokumentet',
  'inv.act.convertOffer': 'Opret',
  'inv.act.convertOfferHelp': 'Opretter en faktura eller ordrebekræftelse som udkast med kunden og linjerne fra tilbuddet.',
  'inv.convert.title': 'Opret fra tilbuddet',
  'inv.convert.invoice': 'Faktura',
  'inv.convert.invoiceHelp': 'Almindelig betalingsfrist. Bogføres, når du opretter den.',
  'inv.convert.order': 'Ordrebekræftelse',
  'inv.convert.orderHelp': 'Bekræfter aftalen uden at fakturere. Kan faktureres senere.',
  'inv.act.markAccepted': 'Markér som accepteret',
  'inv.act.markAcceptedHelp': 'Brug denne, når kunden har accepteret tilbuddet mundtligt, på et møde eller på e-mail. Accept, som kunden selv giver i tilbudslinket, registreres automatisk.',
  'inv.act.undoAccepted': 'Fjern accept',
  'inv.act.undoAcceptedHelp': 'Fortryder en accept, der blev registreret her i appen. Accept, som kunden selv har klikket, kan ikke fjernes.',
  'inv.act.copyHelp': 'Opret en ny faktura med samme indhold som denne.',
  'inv.act.credit': 'Kreditér',
  'inv.act.creditHelp': 'Opret en kreditnota, der modregner denne faktura.',
  'inv.act.delete': 'Slet',
  'inv.act.deleteHelp': 'Slet dette udkast. Kan ikke fortrydes.',
  'inv.err.actionFailed': 'Handlingen kunne ikke fuldføres.',
  'inv.err.openDoc': 'Kunne ikke åbne dokumentet.',
  'inv.err.previewPacking': 'Kunne ikke forhåndsvise pakseddel.',
  'inv.err.settleNotConnected': 'Afregning uden betaling er ikke tilsluttet backend.',
  'inv.err.settleFailed': 'Kunne ikke afregne uden betaling.',
  'inv.err.needEmail': 'Indtast modtagerens e-mail først.',
  'inv.err.emailCharset': 'E-mailadresser må ikke indeholde æ, ø, å eller andre specialtegn.',
  'inv.err.invalidEmail': 'Det ligner ikke en gyldig e-mailadresse.',
  'inv.err.acceptNotConnected': 'Accept er ikke tilsluttet backend.',
  'inv.err.acceptFailed': 'Kunne ikke opdatere accepten.',
  'inv.err.convertNotConnected': 'Konvertering er ikke tilsluttet backend.',
  'inv.err.convertOpenFailed': 'Udkastet blev oprettet, men kunne ikke åbnes.',
  'inv.err.convertFailed': 'Kunne ikke oprette dokumentet fra tilbuddet.',
  'inv.err.copyOpenFailed': 'Kopien blev oprettet, men kunne ikke åbnes.',
  'inv.err.deleteNotConnected': 'Sletning er ikke tilsluttet backend.',
  'inv.err.deleteFailed': 'Kunne ikke slette udkastet.',
  'inv.toast.onlyDrafts': 'Kun udkast kan slettes her',
  'inv.toast.offerAccepted': 'Tilbuddet er markeret som accepteret',
  'inv.toast.offerAcceptanceRemoved': 'Accepten er fjernet',
  'inv.toast.invoiceDraftFromOffer': 'Fakturaen er åbnet — gem den som udkast, eller opret den',
  'inv.toast.orderDraftFromOffer': 'Ordrebekræftelsen er åbnet — gem den som udkast, eller opret den',
  'inv.toast.draftDeleted': 'Udkast slettet',
  'inv.pay.settleWithout': 'Afregnet uden betaling',
  'inv.pay.saveChange': 'Gem ændring',
  'inv.pay.paidDate': 'Betalingsdato',
  'inv.pay.datePh': 'dd.mm.åååå',
  'inv.pay.registerPaymentTitle': 'Registrér betaling',
  'inv.pay.editPaymentTitle': 'Redigér betaling',
  'inv.pay.registerRefundTitle': 'Registrér tilbagebetaling',
  'inv.pay.editRefundTitle': 'Redigér tilbagebetaling',
  'inv.pay.paidFrom': 'Betalt fra',
  'inv.pay.refundDate': 'Tilbagebetalingsdato',
  'inv.pay.refundAmount': 'Tilbagebetalt beløb',
  'inv.pay.remainingNote': 'Resterende på fakturaen: {amount}. Du kan registrere en delbetaling.',
  'inv.pay.refundNote': 'Kunden har {amount} til gode på kreditnotaen. Du kan registrere en delvis tilbagebetaling.',
  'inv.pay.refundHelp': 'Kreditnotaen tilbagefører salget under alle omstændigheder. Registrér kun tilbagebetaling, når kunden faktisk får penge tilbage.',
  'inv.pay.fee': 'Bank- og kortgebyr',
  'inv.pay.feeAccount': 'Gebyrkonto',
  'inv.pay.bankAmountIn': 'Faktisk beløb ind på bank: {amount}',
  'inv.pay.bankAmountOut': 'Faktisk beløb ud af bank: {amount}',
  'inv.detail.offsetCustomerCredit': 'Modregn kundetilgodehavende',
  'inv.detail.customerCreditOffset': 'Modregnet kundetilgodehavende',
  'inv.detail.customerCreditAllocated': 'Modregnet mod anden faktura',
  'inv.detail.relatedRefund': 'Tilbagebetalt via tilhørende kreditnota',
  'inv.toast.customerCreditOffset': 'Kundetilgodehavendet er modregnet mod fakturaen',
  'inv.err.noCustomerCredit': 'Der blev ikke fundet nogen tilgængelig kreditnota for kunden.',
  'inv.err.customerCreditOffsetFailed': 'Kunne ikke modregne kundetilgodehavende.',
  'cust.ledger.creditOffset': 'Modregnet kundetilgodehavende',
  'inv.toast.paymentRegistered': 'Indbetaling registreret',
  'inv.toast.paymentUpdated': 'Betaling opdateret',
  'inv.toast.refundRegistered': 'Tilbagebetaling registreret',
  'inv.toast.refundUpdated': 'Tilbagebetaling opdateret',
  'inv.err.paymentFailed': 'Kunne ikke registrere indbetalingen.',
  'inv.err.paymentUpdateFailed': 'Kunne ikke opdatere betalingen.',
  'inv.err.refundFailed': 'Kunne ikke registrere tilbagebetalingen.',
  'inv.err.refundUpdateFailed': 'Kunne ikke opdatere tilbagebetalingen.',
  'inv.del.confirm': 'Ja, slet udkast',
  'inv.del.body': 'Er du sikker på, at du vil slette dette udkast for {customer}? Dette kan ikke fortrydes.',
  'inv.send.body': '{document} på {amount} sendes til {customer} som PDF på e-mail.',
  'inv.send.resendNote': ' Dette er en ny afsendelse af et allerede sendt dokument.',
  'inv.credit.continue': 'Til kreditering',
  'inv.credit.intro': 'En kreditnota modregner fakturaen for {customer}. Vælg, om du vil kreditere hele fakturaen eller kun dele af den.',
  'inv.credit.full': 'Fuld kreditering',
  'inv.credit.partial': 'Delkreditering',
  'inv.credit.line': 'Linje',
  'inv.credit.count': 'Antal',
  'inv.credit.credited': 'Krediteres',
  'inv.credit.total': 'Kreditnotaens beløb',
  'inv.credit.breakdown': 'Netto {net} · Moms {vat}',
  'inv.credit.partialSuffix': ' · delkreditering',
  'inv.delivery.rowFailed': 'Kom ikke frem',
  'inv.delivery.bannerTitle': '{n} dokumenter kom ikke frem til modtageren',
  'inv.delivery.bannerBody': 'E-mailen blev afvist eller kom retur: {documents}. Åbn dokumentet, ret e-mailadressen på kunden, og send igen.',
  'inv.credit.rest': 'Kreditér resten',
  'inv.credit.alreadyCredited': 'Allerede krediteret: {amount}. Du kan kun kreditere det resterende.',
  'inv.credit.closedLines': '{n} linjer er færdigkrediteret og vises ikke.',
  'inv.credit.lineAlready': 'krediteret {amount}',
  'inv.credit.hasPayments': 'Fakturaen har registrerede betalinger. Kreditnotaen modregner det åbne beløb; en eventuel tilbagebetaling registreres for sig.',
  'inv.credit.date': 'Kreditnotadato',
  'inv.credit.dateHint': 'Datoen afgør, hvilken regnskabs- og momsperiode krediteringen føres i.',
  'inv.credit.dateBeforeInvoice': 'Kreditnotaens dato kan ikke v?re f?r fakturadatoen.',
  'inv.credit.invalidDate': 'Vælg en gyldig dato for kreditnotaen.',
  'inv.credit.paidConfirmTitle': 'Fakturaen er betalt',
  'inv.credit.paidConfirmBody': 'Vi kan se, at fakturaen har registrerede indbetalinger på {amount}. Kreditnotaen tilbagefører salget, men en eventuel tilbagebetaling registreres separat. Vil du fortsætte?',
  'inv.credit.paidConfirmContinue': 'Ja, fortsæt krediteringen',
  'inv.bulk.creditDateHint': 'Samme dato bruges på alle kreditnotaerne. Datoen bestemmer regnskabs- og momsperioden.',
  'inv.bulk.creditDateBeforeInvoices': 'Datoen kan ikke v?re f?r den seneste fakturadato i udvalget.',
  'inv.bulk.creditPaidConfirmBody': '{n} af de valgte fakturaer har registrerede indbetalinger. Kreditnotaerne tilbagefører salgene, men eventuelle tilbagebetalinger registreres separat. Vil du fortsætte?',
  'inv.history.creditPartial': 'Delvist krediteret {amount} · kreditnota {document}',
  'inv.history.creditFull': 'Krediteret {amount} · kreditnota {document}',
  'inv.history.creditDraft': 'Kreditnota {document} oprettet som kladde · {amount}',
  'inv.history.creditNoNumber': 'uden nummer',
  'inv.toast.creditOpened': 'Kreditnota for {document} er åbnet — udfyld årsag, og opret den',
  'inv.toast.partialCreditOpened': 'Delkreditnota for {document} er åbnet — udfyld årsag, og opret den',
  'inv.bulk.selectAll': 'Vælg alle viste',
  'inv.bulk.selectRow': 'Vælg dokument. Shift-klik vælger intervallet.',
  'inv.bulk.selectDocument': 'Vælg dokument',
  'inv.bulk.selectDocuments': 'Vælg dokumenter',
  'inv.bulk.selectedCount': '{n} valgt',
  'inv.bulk.shownCount': '{n} vises på listen',
  'inv.bulk.reset': 'Nulstil',
  'inv.bulk.deliver': 'Markér som leveret',
  'inv.bulk.resend': 'Send igen',
  'inv.bulk.reminder': 'Rykker',
  'inv.bulk.credit': 'Kreditér',
  'inv.bulk.issue': 'Opret og send',
  'inv.bulk.delete': 'Slet',
  'inv.bulk.processing': 'Behandler ...',
  'inv.bulk.document': 'Dokument',
  'inv.bulk.amount': 'Beløb',
  'inv.bulk.more': '+ {n} flere',
  'inv.bulk.noEmail': 'mangler e-mail',
  'inv.bulk.newDueDate': 'ny frist {date}',
  'inv.bulk.reminderType': 'Type',
  'inv.bulk.reminderNotice': 'Betalingspåmindelse',
  'inv.bulk.reminderDunning': 'Rykker',
  'inv.bulk.reminderDueDays': 'Dage til ny frist',
  'inv.bulk.reminderFee': 'Rykkergebyr',
  'inv.bulk.reminderFeeLocked': 'Gebyr kan kun pålægges ved rykker.',
  'inv.bulk.delivery': 'Sendes som',
  'inv.bulk.deliveryPdf': 'PDF-vedhæftning',
  'inv.bulk.deliveryLink': 'Link',
  'inv.bulk.comment': 'Kommentar til kunden',
  'inv.bulk.commentHint': 'Står i e-mailen sammen med beløbsoversigten. Selve fakturaen ændres ikke.',
  'inv.bulk.commentPh': 'For eksempel: Vi kan se, at fakturaen står ubetalt. Kontakt os, hvis noget er uklart.',
  'inv.comment.label': 'Kommentar til kunden',
  'inv.comment.hint': 'Valgfri tekst, der følger med denne udsendelse.',
  'inv.comment.placeholder': 'Skriv en kommentar ...',
  'inv.comment.useSaved': 'Brug kommentar',
  'inv.comment.save': 'Gem kommentar',
  'inv.comment.update': 'Opdater kommentar',
  'inv.comment.saveTitle': 'Gem kommentar',
  'inv.comment.updateTitle': 'Opdater kommentar',
  'inv.comment.saveAsNew': 'Gem som ny',
  'inv.comment.savedTitle': 'Gemte kommentarer',
  'inv.comment.name': 'Navn på kommentaren',
  'inv.comment.namePh': 'For eksempel: Venlig påmindelse',
  'inv.comment.nameHint': 'Navnet er det, du finder kommentaren igen på i listen.',
  'inv.comment.needName': 'Giv kommentaren et navn først',
  'inv.comment.empty': 'Du har ingen gemte kommentarer endnu.',
  'inv.comment.use': 'Brug',
  'inv.comment.saved': 'Kommentar gemt',
  'inv.comment.updated': 'Kommentar opdateret',
  'inv.comment.deleted': 'Kommentar slettet',
  'inv.comment.saveFailed': 'Kunne ikke gemme kommentaren.',
  'inv.comment.deleteFailed': 'Kunne ikke slette kommentaren.',
  'inv.comment.notConnected': 'Kommentarer er ikke forbundet til backend.',
  'inv.bulk.mode': 'Hvad skal der ske',
  'inv.bulk.mode.draft': 'Gem som kladde',
  'inv.bulk.mode.send': 'Opret og send',
  'inv.bulk.mode.create': 'Kun opret',
  'inv.bulk.mode.hint.credit': 'Kreditnotaerne lægges i fanen Kladder. Intet bogføres eller sendes, før du opretter dem.',
  'inv.bulk.mode.hint.creditSend': 'Kreditnotaerne bogføres og sendes til kunderne med det samme. Dette kan ikke fortrydes.',
  'inv.bulk.mode.hint.issueSend': 'Kladderne bogføres med dokumentnummer og sendes til kunderne på e-mail.',
  'inv.bulk.mode.hint.issue': 'Kladderne bogføres med dokumentnummer, men der sendes ingen e-mail.',
  'inv.bulk.creditReasonOptional': 'Valgfrit, så længe kreditnotaen ligger som kladde. Årsagen skal være på plads, før den kan bogføres.',
  'inv.bulk.creditReasonRequired': 'Påkrævet. Årsagen står på kreditnotaen og er grundlaget for, at salget blev tilbageført.',
  'inv.bulk.title.deliver': 'Markér valgte dokumenter som leveret',
  'inv.bulk.title.send': 'Send valgte dokumenter igen',
  'inv.bulk.title.reminder': 'Send rykker eller betalingspåmindelse',
  'inv.bulk.title.credit': 'Kreditér valgte fakturaer',
  'inv.bulk.title.issue': 'Opret valgte kladder',
  'inv.bulk.title.delete': 'Slet valgte kladder',
  'inv.bulk.confirm.deliver': 'Markér som leveret',
  'inv.bulk.confirm.send': 'Send igen',
  'inv.bulk.confirm.reminder': 'Send opfølgning',
  'inv.bulk.confirm.credit': 'Opret kreditnotaer',
  'inv.bulk.confirm.creditSend': 'Opret og send kreditnotaer',
  'inv.bulk.confirm.issue': 'Opret dokumenterne',
  'inv.bulk.confirm.issueSend': 'Opret og send',
  'inv.bulk.confirm.delete': 'Ja, slet kladderne',
  'inv.bulk.body.deliver': 'Dokumenter, der markeres som leveret uden for Plumme: {n}. Der sendes ingen e-mail, og bogføring og betaling ændres ikke.',
  'inv.bulk.body.send': '{n} dokumenter sendes til den e-mailadresse, der er registreret på kunden.',
  'inv.bulk.body.reminder': '{n} forfaldne eller ubetalte fakturaer følges op. Den oprindelige faktura bogføres ikke igen.',
  'inv.bulk.body.credit': '{n} fakturaer krediteres for det resterende, én kreditnota pr. faktura. Allerede krediterede linjer medtages ikke igen.',
  'inv.bulk.body.creditSend': '{n} fakturaer krediteres for det resterende. Kreditnotaerne oprettes, bogføres og sendes til kunden med det samme — du slipper for at gå via kladder.',
  'inv.bulk.body.issue': '{n} kladder oprettes og bogføres og får dokumentnummer.',
  'inv.bulk.body.issueSend': '{n} kladder oprettes, bogføres og sendes til kunden på e-mail.',
  'inv.bulk.body.delete': '{n} kladder slettes. Kladder er ikke bogført, men sletningen kan ikke fortrydes.',
  'inv.bulk.skip.deliver': 'Valgte rækker, der er kladder, allerede leveret eller sendt, og som springes over: {n}.',
  'inv.bulk.skip.send': '{n} valgte dokumenter mangler e-mail og springes over.',
  'inv.bulk.skip.reminder': '{n} valgte rækker kan ikke rykkes her eller mangler e-mail.',
  'inv.bulk.skip.credit': '{n} valgte rækker kan ikke krediteres her.',
  'inv.bulk.skip.issue': '{n} valgte kladder mangler kunde eller linjer og kan ikke oprettes herfra.',
  'inv.bulk.skip.noEmail': '{n} af dokumenterne mangler e-mailadresse. De oprettes og bogføres, men sendes ikke.',
  'inv.bulk.skip.delete': '{n} valgte rækker er ikke kladder og slettes ikke.',
  'inv.bulk.toast.delivered': 'Dokumenter markeret som leveret: {n}',
  'inv.bulk.toast.sent': '{n} dokumenter sendt',
  'inv.bulk.toast.reminded': '{n} betalingspåmindelser sendt',
  'inv.bulk.toast.dunned': '{n} rykkere sendt',
  'inv.bulk.toast.credited': '{n} kreditnotaer oprettet som kladder',
  'inv.bulk.toast.creditedSent': '{n} kreditnotaer oprettet og sendt',
  'inv.bulk.toast.issued': '{n} dokumenter oprettet',
  'inv.bulk.toast.issuedSent': '{n} dokumenter oprettet og sendt',
  'inv.bulk.toast.deleted': '{n} kladder slettet',
  'inv.bulk.toast.notSentSuffix': ', {n} oprettet uden e-mail',
  'inv.bulk.toast.failedSuffix': ', {n} mislykkedes',
  'inv.bulk.err.failed': 'Kunne ikke fuldføre massehandlingen.',
  'inv.bulk.err.deliverNotConnected': 'Markering som leveret er ikke forbundet til backend.',
  'inv.bulk.err.sendNotConnected': 'Afsendelse er ikke forbundet til backend.',
  'inv.bulk.err.creditNotConnected': 'Kreditering er ikke forbundet til backend.',
  'inv.bulk.err.issueNotConnected': 'Oprettelse af udkast er ikke koblet til backend.',
  'inv.packing.preview': 'Forhåndsvis',
  'inv.packing.download': 'Download følgeseddel',
  'inv.packing.invoiceDate': 'Fakturadato',
  'inv.pay.account.1920': 'Driftskonto - 1920',
  'inv.pay.account.2063': 'Privat - 2063',
  'inv.pay.account.1900': 'Kontanter - 1900',
  'inv.report.customer': 'Kunde',
  'inv.report.product': 'Produkt',
  'inv.report.salesCount': 'Antal salg',
  'inv.report.count': 'Antal',
  'inv.report.exVat': 'Ekskl. moms',
  'inv.report.share': 'Andel af total',
  'inv.report.noSales': 'Intet salg i perioden.',
  'inv.report.noProducts': 'Ingen produkter solgt i perioden.',
  'inv.report.openCustomer': 'Åbn {name} i Kunder',
  'inv.report.totalCustomers': '({n} kunder)',
  'inv.report.totalCustomer': '({n} kunde)',
  'inv.report.totalProducts': '({n} produkter)',
  'inv.report.totalProduct': '({n} produkt)',
  'inv.report.total': 'I alt',
  'inv.report.tile.sales': 'Salg',
  'inv.report.tile.activeCustomers': 'Aktive kunder',
  'inv.report.tile.newCustomers': 'Nye kunder',
  'inv.report.tile.totalCustomers': 'Kunder i alt',
  'inv.report.tile.customerRevenue': 'Kundeindtægter',
  'inv.report.tile.totalRevenue': 'Samlede indtægter',
  'inv.report.tile.soldProducts': 'Solgte produkter',
  'inv.report.tile.productTypes': 'Produkttyper',
  'inv.report.tile.productRevenue': 'Produktindtægter',
  'inv.report.unknownCustomer': 'Ukendt kunde',
  'inv.report.unspecifiedSale': 'Uspecificeret salg',
  'inv.report.customerSummaryOne': 'Der blev registreret {sales} salg til {customers} kunde i perioden. Salg til kunder udgjorde {amount}.',
  'inv.report.customerSummaryMany': 'Der blev registreret {sales} salg til {customers} kunder i perioden. Salg til kunder udgjorde {amount}.',
  'inv.report.productSummaryOne': 'Der blev solgt {count} produkter/linjer i perioden af {types} produkttype, for i alt {amount}.',
  'inv.report.productSummaryMany': 'Der blev solgt {count} produkter/linjer i perioden af {types} produkttyper, for i alt {amount}.',
  'inv.fallback.noCustomer': 'Uden kunde',
  'inv.fallback.line': 'Linje {n}',
  'inv.credit.fallbackDescription': 'Salg iht. {document}',
  'inv.credit.dialogTitle': 'Krediter faktura {number}',
  'inv.detail.validUntil': 'Gyldig til',
  'inv.detail.dueDate': 'Forfald',
  'inv.detail.partiallyPaid': 'Delvist betalt',
  'inv.detail.unpaid': 'Ikke betalt',
  'inv.detail.acceptedManual': 'Accepteret {date} · registreret i appen',
  'inv.detail.acceptedCustomer': 'Accepteret {date} · af kunden',
  'inv.detail.orderSentAt': 'Ordrebekræftelse sendt {date}',
  'inv.detail.paymentFeeBank': 'Gebyr {fee} · Bank {bank}',
  'inv.detail.deliveryFailureHelp': 'Dokumentet er gemt, men modtageren har ikke fået det. Ret adressen på kunden, og send igen.',
  'inv.detail.timelineHelp': 'Tidslinje bygget ud fra gemt dokumentstatus og betalinger.',
  'inv.history.offerAcceptedManual': 'Tilbud markeret som accepteret (registreret i appen)',
  'inv.history.offerAcceptedCustomer': 'Tilbud accepteret af kunden',
  'inv.history.orderSent': 'Ordrebekræftelse sendt',
  'inv.history.documentSentTo': '{document} sendt til {recipient}',
  'inv.history.deliveredExternally': 'Leveret uden for Plumme',
  'inv.history.documentCreated': 'Dokument oprettet',
  'inv.packing.intro': 'Angiv dato for afsendelse. Dagens dato er valgt som standard.',
  'inv.packing.shippingDate': 'Afsendelsesdato',
  'inv.packing.contents': 'Følgesedlen viser beskrivelser og antal fra fakturalinjerne. Priser, moms og betalingsoplysninger vises ikke.',
  'inv.packing.title': 'Følgeseddel {number}',
  'inv.err.pdfPreviewNotConnected': 'PDF-visning er ikke koblet til backend.',
  'inv.err.packingNotConnected': 'Følgeseddel er ikke koblet til backend.',
  'inv.err.packingDownloadFailed': 'Kunne ikke downloade følgesedlen.',
  'inv.err.paymentNotConnected': 'Indbetaling er ikke koblet til backend.',
  'inv.err.paymentEditNotConnected': 'Redigering af betalinger er ikke koblet til backend.',
  'inv.err.sendNotConnected': 'Afsendelse er ikke koblet til backend.',
  'inv.err.sendFailed': 'Kunne ikke sende dokumentet.',
  'inv.err.deliverNotConnected': 'Markering som leveret er ikke koblet til backend.',
  'inv.err.deliverFailed': 'Kunne ikke markere dokumentet som leveret.',
  'inv.err.linkNotConnected': 'Fakturalink er ikke koblet til backend.',
  'inv.err.linkFailed': 'Kunne ikke hente fakturalink.',
  'inv.err.downloadNotConnected': 'PDF-download er ikke koblet til backend.',
  'inv.err.downloadFailed': 'Kunne ikke downloade dokumentet.',
  'inv.err.copyNotConnected': 'Kopiering er ikke koblet til backend.',
  'inv.err.copyFailed': 'Kunne ikke lave en kopi af dokumentet.',
  'inv.err.archiveNotConnected': 'Arkivering er ikke koblet til backend.',
  'inv.err.archiveFailed': 'Kunne ikke opdatere arkivstatus.',
  'inv.err.creditNotConnected': 'Kreditering er ikke koblet til backend.',
  'inv.err.creditFailed': 'Kunne ikke oprette kreditnota.',
  'inv.toast.packingDownloading': 'Følgesedlen downloades',
  'inv.toast.settledWithoutPayment': 'Fakturaen er udlignet uden betaling',
  'inv.toast.sendingBackground': '{document} sendes i baggrunden',
  'inv.toast.documentSent': '{document} sendt',
  'inv.toast.deliveredExternally': 'Dokumentet er markeret som leveret',
  'inv.toast.readyNoEmail': 'Dokumentet er klargjort, men der blev ikke sendt nogen e-mail.',
  'inv.toast.linkCopied': 'Link til {number} kopieret',
  'inv.toast.documentDownloading': 'Dokumentet downloades',
  'inv.toast.archiveRestored': 'Hentet ud af arkivet',
  'inv.toast.archived': 'Arkiveret',
  'inv.toast.creditCreated': '{document} oprettet for {number}',
  'inv.act.unarchive': 'Hent ud af arkivet',
  'inv.act.archive': 'Arkiver',
  'inv.act.archiveHelp': 'Flyt tilbuddet eller ordrebekræftelsen til arkivet, eller hent det ud igen.',
  'inv.convert.alreadyTitle': 'Tilbuddet er allerede lavet om til:',
  'inv.convert.duplicateWarning': 'Opretter du et til, skal du selv sørge for, at kunden ikke bliver faktureret for samme opgave to gange.',
  'inv.convert.footerHelp': 'Begge oprettes som udkast med kunden og linjerne fra tilbuddet og åbnes i salgsflowet.',
  'inv.send.title': 'Send {document} {number}',
  'inv.deliver.title': 'Marker som leveret',
  'inv.deliver.body': 'Brug dette, når dokumentet allerede er leveret til kunden på anden vis. Der sendes ingen e-mail fra Plumme. Bogføring, moms og betalingsstatus ændres ikke, men påmindelser om ikke-sendt dokument stopper.',
  'inv.delivery.external': 'Leveret uden for Plumme',
  'inv.more': 'Mere',
  'inv.err.offerAlreadyConverted': 'Tilbuddet er allerede konverteret til denne dokumenttype.',
  'sale.totalDiscount': 'Samlet rabat',
  'sale.totalDiscountHelp': 'Fordeles forholdsmæssigt på alle produktlinjer og gemmes med sporbar fordeling.',
  'sale.det.currency': 'Dokumentvaluta',
  'sale.det.exchangeRate': 'Kurs til {currency}',
  'sale.det.exchangeRateDate': 'Kursdato',
  'sale.det.exchangeRateSource': 'Kilde for kurs',
  'sale.det.exchangeRateSourcePh': 'For eksempel Norges Bank eller aftalt kurs',
  'sale.create.needCurrencyEvidence': 'Angiv en positiv kurs, kursdato og kilde, før fakturaen oprettes.',
  'sale.preview.accountingAmount': 'Regnskabsbeløb: {amount} {currency} · kurs {rate}',
  'sale.preview.vatAccountingAmount': 'Moms i {currency}: {amount}',
});
